export default {
  promoList: [],
  promoData: {items: [], _links: {}, _meta: {}},
  promoListExpired: [],
  promoDataExpired: {items: [], _links: {}, _meta: {}},
  reminderList: [],
  reminderData: {items: [], _links: {}, _meta: {}},
  birthdayList: [],
  birthdayData: {items: [], _links: {}, _meta: {}},
  // clientList: [],
  // clientData: {items: [], _links: {}, _meta: {}},
  newClient: {campaign: {}, campaign_report: {}},
  groupList:[],
  promotionInfo: {campaign: {}, campaign_report: {}, promotion_campaign :{}},
  reminderInfo: {campaign: {}, campaign_report: {}, remind_campaign :{}},
  birthdayInfo: {campaign: {}, campaign_report: {}, birthday_campaign :{}},
  campaignHistoryList: {items: [], _links: {}, _meta: {}},
}
